module.exports = __webpack_public_path__ + "img/Frame 5134.d5adaab8.jpg";